<template>
  <v-container fluid>
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <v-tabs
          color="transparent"
          slider-color="primary"
          v-model="tab"
        >
          <v-tab
            v-for="(tab, index) of tabs"
            :key="`tab${index}`"
          >
            {{ tab.title }}
          </v-tab>
        </v-tabs>

        <data-table
          :resource="resources[tabs[tab].resource]"
          loading="loading"
          :key="'data-table' + tab"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { pickBy } from "lodash";

export default {
  data() {
    return {
      tabs: [
        { title: "קבוצות תקנים", resource: "standardGroup" },
        { title: "תקנים", resource: "standard" },
      ],
      tab: 0,
      loading: false
    };
  },

  computed: {
    resources() {
      return this.$store.state.resources;
    }
  },

  methods: {
    fetch() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch("API_GET", {
          url: "/standards",
          entityType: "standards",
          schema: "standardListSchema"
        }),
        this.$store
        .dispatch("API_GET", {
          url: "/standard-groups",
          entityType: "standardGroups",
          schema: "standardGroupListSchema"
        })
      ])
        .finally(() => {
          this.loading = false;
        });
    }
  },

  mounted() {
    this.fetch();
  },

  components: {
    DataTable
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/Standards.vue